export const ALL_MEASURE_OPTION_TYPES = ['COUNT', 'PERCENT', 'SUM', 'AVG', 'MIN', 'MAX'] as const;
export type MeasureOptionType = typeof ALL_MEASURE_OPTION_TYPES[number];

export interface MeasureOption {
  /** Display value for the option */
  label: string;
  /** Type of measure */
  type: MeasureOptionType;
  /** Whether the option requires a variable selection */
  requiresVariable?: boolean;
}

export const MEASURE_OPTIONS: Record<MeasureOptionType, MeasureOption> = {
  COUNT: { label: $localize`Count`, type: 'COUNT' },
  PERCENT: { label: $localize`Percent`, type: 'PERCENT' },
  SUM: { label: $localize`Sum`, type: 'SUM', requiresVariable: true },
  // As of 2019-10-16
  // The backend hasn't supported totals with these measures
  // If we want to use them we need to be able to turn off the totals when these are selected
  AVG: { label: $localize`Average`, type: 'AVG', requiresVariable: true },
  MIN: { label: $localize`Minimum`, type: 'MIN', requiresVariable: true },
  MAX: { label: $localize`Maximum`, type: 'MAX', requiresVariable: true },
};
